import { StyledFlex } from "@/common/styles";
import { useState } from "react";
import ReportEmailPdfModal from "./ReportEmailPdfModal";
import Button from "@/common/elements/Button";
import DropdownV2 from "@/common/elements/DropdownV2";

const CommonReportActionHeader = ({ onClose = () => {}, onExportClick, handlePrintClick }) => {
  const [isEmailPdfModal, setIsEmailPdfModal] = useState(false);

  const handleClose = () => {
    onClose(true);
  };

  const handleExport = (item) => {
    // const currentItem = item?.key?.split("export-");
    // const currentExport = currentItem[1];
    onExportClick();
  };

  return (
    <>
      <StyledFlex gap={"10px"} justify="center">
        <Button type="secondary" color="secondary" onClick={handleClose}>
          Close
        </Button>

        <Button type="secondary" color="secondary" onClick={handlePrintClick}>
          Print
        </Button>

        <DropdownV2
          onSelect={handleExport}
          menuItems={[
            // { key: "export-excel", label: "Excel" },
            // { key: "export-html", label: "HTML" },
            { key: "export-pdf", label: "PDF" },
          ]}
          trigger={["click"]}
          content={
            <Button type="secondary" color="secondary">
              Export
            </Button>
          }
        />

        {/* <Button type="secondary" color="secondary" 
              onClick={()=>setIsEmailPdfModal(true)}>
                Email PDF
              </Button> */}
      </StyledFlex>

      {isEmailPdfModal && (
        <ReportEmailPdfModal
          size="md"
          show={isEmailPdfModal}
          onHide={() => setIsEmailPdfModal(false)}
        />
      )}
    </>
  );
};
export default CommonReportActionHeader;
